<template>
    <div class="material-detail-header">
        <div class="material-detail-title">
            <div class="title">
                {{ renderData.materialtitle }}
            </div>
            <span class="hot">
                {{ renderData.heatdegree }}
            </span>
        </div>
        <div class="material-tags">
            <span class="tag-item" v-for="(tag, index) in renderData.materialtag" :title="tag" :key="index">{{ tag }}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MaterialDetailHeader',
    props: {
        detailData: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            renderData: {}
        };
    },
    watch: {
        detailData() {
            this.renderData = this.detailData;
            this.renderData.materialtag = this.detailData.materialtag.split(';');
        }
    },
    mounted() {},
    methods: {}
};
</script>
<style lang="scss" scoped>
@import '../style/common.scss';
@import './style/material-detail-header.scss';
</style>
